import "./newPeople.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import {
  TextField,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  FormHelperText,
} from "@mui/material";
import { NepaliDatePicker } from "nepali-datepicker-reactjs";
import { useSelector } from "react-redux";

const NewPeople = ({ inputs, title }) => {
  const userIdRedux = useSelector((state) => state.user.userId);
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const navigate = useNavigate();
  const { state } = useLocation();
  const peopleData = state?.people || {};

  const [formData, setFormData] = useState({
    userId: peopleData.userId || userIdRedux,
    fullName: peopleData.fullName || "",
    fatherName: peopleData.fatherName || "",
    motherName: peopleData.motherName || "",
    grandFatherName: peopleData.grandFatherName || "",
    gender: peopleData.gender || "Male",
    dob: peopleData.dob || "",
    status: peopleData.status || "Live",
  });

  const [dob, setDob] = useState(peopleData.dob || "");

  const [errors, setErrors] = useState({});
  const [backEndError, setBackEndError] = useState("");

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const validateForm = () => {
    const errors = {};
    if (!formData.fullName) errors.fullName = "Full Name is required.";
    // if (!/^[a-zA-Z\s]+$/.test(formData.fullName))
    //   errors.fullName = "Full Name must be a string.";

    if (!formData.fatherName) errors.fatherName = "Father Name is required.";
    // if (!/^[a-zA-Z\s]+$/.test(formData.fatherName))
    //   errors.fatherName = "Father Name must be a string.";

    if (!formData.motherName) errors.motherName = "Mother Name is required.";
    // if (!/^[a-zA-Z\s]+$/.test(formData.motherName))
    //   errors.motherName = "Mother Name must be a string.";

    if (!formData.grandFatherName)
      errors.grandFatherName = "Grand Father Name is required.";
    // if (!/^[a-zA-Z\s]+$/.test(formData.motherName))
    //   errors.motherName = "Grand Father Name must be a string.";

    if (!dob) errors.dob = "Date Of Birth is required.";

    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    const formDataToSubmit = new FormData();
    formDataToSubmit.append("userId", formData.userId);
    formDataToSubmit.append("fullName", formData.fullName);
    formDataToSubmit.append("fatherName", formData.fatherName);
    formDataToSubmit.append("motherName", formData.motherName);
    formDataToSubmit.append("grandFatherName", formData.grandFatherName);
    formDataToSubmit.append("dob", dob);
    formDataToSubmit.append("gender", formData.gender);
    formDataToSubmit.append("status", formData.status);

    const MAIN_URL = peopleData._id
      ? `${BASE_URL}/api/people/updatePeople/${peopleData._id}`
      : `${BASE_URL}/api/people/addPeople`;

    try {
      let response = "";
      if (peopleData._id) {
        response = await axios.put(MAIN_URL, formDataToSubmit, {
          headers: {
            "Content-Type": "application/json",
          },
        });
      } else {
        response = await axios.post(MAIN_URL, formDataToSubmit, {
          headers: {
            "Content-Type": "application/json",
          },
        });
      }

      if (response.status === 201) {
        setBackEndError(<font color="green">Success TO ADD DATA.</font>);
        navigate("/people");
      } else if (response.status === 200) {
        setBackEndError(<font color="green">Success TO UPDATE DATA.</font>);
        navigate("/people");
      } else if (response.status === 401) {
        setBackEndError(<font color="red">People ALREADY EXISTS.</font>);
      } else if (response.status === 400) {
        setBackEndError(<font color="red">ALL THE FIELDS ARE REQUIRED.</font>);
      } else if (response.status === 402) {
        setBackEndError(<font color="red">INVALID People DATA.</font>);
      }
    } catch (error) {
      const errorMessage = error.response.data.msg;
      setBackEndError(<span style={{ color: "red" }}>{errorMessage}</span>);
    }
  };
  return (
    <div className="newUser">
      <Sidebar />
      <div className="newUserContainer">
        <Navbar />
        <div className="top">
          <h1>{title}</h1>
        </div>
        <div className="bottom">
          <form
            onSubmit={handleSubmit}
            style={{
              display: "grid",
              gap: "1rem",
              width: "100%",
            }}
          >
            <div style={{ display: "flex", gap: "16px" }}>
              <TextField
                style={{ flex: 3 }}
                name="fullName"
                label="Full Name"
                type="text"
                value={formData.fullName}
                onChange={handleInputChange}
                error={Boolean(errors.fullName)}
                helperText={errors.fullName}
                fullWidth
                margin="normal"
                required
              />
              <div style={{ flex: 3 }}>
                <InputLabel style={{ flex: 1 }}>Date Of Birth</InputLabel>
                <FormControl
                  style={{ flex: 2 }}
                  margin="normal"
                  error={Boolean(errors.dob)}
                >
                  <NepaliDatePicker
                    inputClassName="form-control"
                    value={dob}
                    onChange={(value) => setDob(value)}
                    options={{ calenderLocale: "ne", valueLocale: "en" }}
                  />
                  {errors.dob && <FormHelperText>{errors.dob}</FormHelperText>}
                </FormControl>
              </div>
              <label style={{ visibility: "hidden", flex: 6 }}></label>
            </div>
            <div style={{ display: "flex", gap: "16px" }}>
              <TextField
                style={{ flex: 3 }}
                name="fatherName"
                label="Father Name"
                type="text"
                value={formData.fatherName}
                onChange={handleInputChange}
                error={Boolean(errors.fatherName)}
                helperText={errors.fatherName}
                fullWidth
                margin="normal"
                required
              />
              {/* Another TextField or empty space for 1/4 size */}
              <TextField
                style={{ flex: 3 }}
                name="motherName"
                label="Mother Name"
                type="text"
                value={formData.motherName}
                onChange={handleInputChange}
                error={Boolean(errors.motherName)}
                helperText={errors.motherName}
                fullWidth
                margin="normal"
                required
              />
              <label style={{ visibility: "hidden", flex: 6 }}></label>
            </div>
            <div style={{ display: "flex", gap: "16px" }}>
              <TextField
                style={{ flex: 3 }}
                name="grandFatherName"
                label="Grand Father Name"
                type="text"
                value={formData.grandFatherName}
                onChange={handleInputChange}
                error={Boolean(errors.grandFatherName)}
                helperText={errors.grandFatherName}
                fullWidth
                margin="normal"
                required
              />
              {/* Another Select or empty space for 1/4 size */}
              <FormControl style={{ flex: 3 }} margin="normal">
                <InputLabel>Gender</InputLabel>
                <Select
                  name="gender"
                  value={formData.gender}
                  onChange={handleInputChange}
                >
                  <MenuItem value="Male">Male</MenuItem>
                  <MenuItem value="Female">Female</MenuItem>
                  <MenuItem value="Other">Other</MenuItem>
                </Select>
              </FormControl>
              <label style={{ visibility: "hidden", flex: 6 }}></label>
            </div>

            <div style={{ display: "flex", gap: "16px" }}>
              <FormControl style={{ flex: 3 }} margin="normal">
                <InputLabel>Status</InputLabel>
                <Select
                  name="status"
                  value={formData.status}
                  onChange={handleInputChange}
                >
                  <MenuItem value="Live">Live</MenuItem>
                  <MenuItem value="Death">Death</MenuItem>
                </Select>
              </FormControl>

              <label style={{ visibility: "hidden", flex: 9 }}></label>
            </div>

            <span className="error-message">{backEndError}</span>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              style={{ borderRadius: "15px", width: "50%" }}
            >
              Submit
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default NewPeople;
